

import { Control } from 'react-hook-form';
import { ProfileFormValues } from '../ProfileFormSchema';
import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

// Stripe options
const stripeOptions = [
  { value: '0', label: 'No Stripes' },
  { value: '1', label: '1 Stripe' },
  { value: '2', label: '2 Stripes' },
  { value: '3', label: '3 Stripes' },
  { value: '4', label: '4 Stripes' },
];

type StripesSelectorProps = {
  control: Control<ProfileFormValues>;
};

export function StripesSelector({ control }: StripesSelectorProps) {
  return (
    <FormField
      control={control}
      name="stripes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Stripes</FormLabel>
          <Select 
            onValueChange={field.onChange}
            value={field.value || '0'}
            defaultValue="0"
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select number of stripes" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {stripeOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
